import React from 'react';
import PropTypes from 'prop-types';

import Snackbar from '@material-ui/core/Snackbar';

class CoreSnackbar extends React.PureComponent {
  static propTypes = {
    currentSnackbarOpen: PropTypes.bool.isRequired,
    currentSnackbar: PropTypes.string,
    expireSnackbar: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Snackbar
        open={this.props.currentSnackbarOpen}
        message={this.props.currentSnackbar || ''}
        onClose={this.props.expireSnackbar}
        autoHideDuration={4000}
      />
    );
  }
}

export default CoreSnackbar;
